import {computed, makeObservable, observable} from 'mobx';

import type {DateTimeModel} from '../../../core/domain/Date/DateTime.model';
import type {Nullable} from '../../../utils/utility-types';

export class DataFilterState {
  constructor(
    public search: DataFilterState.Search = null,
    public datesFilter: DataFilterState.DatesFilter = null,
    public fields: DataFilterState.Fields = null,
  ) {
    makeObservable(this, {
      datesFilter: observable,
      fields: observable,
      isClear: computed,
      search: observable,
    });
  }

  get isClear() {
    return !this.search && !this.datesFilter && !this.fields;
  }

  addField(field: DataFilterState.Field) {
    const fields = this.fields || new Map<string, DataFilterState.Field>();

    const maybeExistingField = fields.get(field.key);

    if (maybeExistingField) {
      field.values.forEach(value => maybeExistingField.values.add(value));
    } else {
      fields.set(field.key, field);
    }

    return this.updateFields(new Map(fields));
  }

  updateDates(datesFilter: DataFilterState.DatesFilter) {
    return new DataFilterState(this.search, datesFilter, this.fields);
  }

  updateFields(fields: DataFilterState.Fields) {
    return new DataFilterState(this.search, this.datesFilter, fields);
  }

  updateSearch(search: DataFilterState.Search) {
    return new DataFilterState(search, this.datesFilter, this.fields);
  }
}

export namespace DataFilterState {
  export type DatesFilter = Nullable<{
    end: Nullable<DateTimeModel>;
    start: Nullable<DateTimeModel>;
  }>;
  export type Field = {key: string; values: Set<string>};
  export type Fields = Nullable<Map<string, Field>>;
  export type Search = Nullable<string>;
}
